/**
 * GraphQL type definitions matching backend schema — audit pillar.
 * Split from graphql/types.ts (issue #1409).
 */

export type AuditActorType = 'User' | 'Service' | 'System';
export type AuditResult = 'Success' | 'Failure';

export enum AuditAction {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted',
  ACCESSED = 'accessed',
  EXPORTED = 'exported',
  GRANTED = 'granted',
  DENIED = 'denied',
}

export interface AuditActor {
  type: AuditActorType;
  id: string;
  name: string;
  email?: string | null;
  ipAddress?: string | null;
  userAgent?: string | null;
}

export interface AuditResource {
  type: string;
  id: string;
  name?: string | null;
}

export interface AuditContext {
  requestId: string;
  sessionId?: string | null;
  source: string;
  bulkOperationId?: string | null;
}

export interface AuditEvent {
  eventId: string;
  eventType: string;
  timestamp: string;
  actor: AuditActor;
  resource: AuditResource;
  action: AuditAction;
  actionDetails?: string | null;
  context: AuditContext;
  result: AuditResult;
  errorCode?: string | null;
  errorMessage?: string | null;
  tags?: string[] | null;
  entityOwnerId?: string | null;
  entityTeamId?: string | null;
}

export interface AuditEventsPage {
  items: AuditEvent[];
  nextCursor?: string | null;
  count: number;
  totalCount: number;
  isScoped: boolean;
}

export interface AuditEventFilter {
  actorId?: string;
  entityId?: string;
  entityType?: string;
  action?: AuditAction;
  dateFrom: string;
  dateTo: string;
  limit?: number;
}
